// Frontend API bindings for the P0 workflow features.
import { API } from './_client';

export const workflow = {
  stages: () => API.get('/workflow/stages').then((r) => r.data),
  setStage: (matterId, stage, note = null) => API.post(`/workflow/${matterId}/stage`, { stage, note }).then((r) => r.data),
  history: (matterId) => API.get(`/workflow/${matterId}/history`).then((r) => r.data),
};

export const anzsco = {
  suggestBody: (code) => API.post('/anzsco/assessing-body', { anzsco: code }).then((r) => r.data),
  bodies: () => API.get('/anzsco/assessing-bodies').then((r) => r.data),
};

export const filenotesV2 = {
  add: (matterId, payload) => API.post(`/filenotes/${matterId}`, payload).then((r) => r.data),
  list: (matterId) => API.get(`/filenotes/${matterId}`).then((r) => r.data),
};

export const points = {
  table: () => API.get('/points/table').then((r) => r.data),
  get: (matterId) => API.get(`/points/${matterId}`).then((r) => r.data),
  save: (matterId, selectedIds, note = null) => API.post(`/points/${matterId}`, { selected_ids: selectedIds, note }).then((r) => r.data),
};

export const checklist = {
  get: (matterId) => API.get(`/checklist/${matterId}`).then((r) => r.data),
  tick: (matterId, itemId, done, label = null) => API.post(`/checklist/${matterId}`, { item_id: itemId, done, label }).then((r) => r.data),
};
